// ShapeSection.jsx
import React from "react";
import "./ShapeSection.css";

import { motion } from "framer-motion";
import Shape from "../assets/images/shape.png";

const ShapeSection = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: false, amount: 0.3 }}
    >
      <section className="shape-section">
        <div className="container-shape">
          <div className="content-shape">
            <h1>Let’s shape the future of intelligent, sustainable cities together.</h1>
            <div className="button-group">
               <a 
            href="/book" 
            className="primary-btn" 
            style={{ textDecoration: 'none', display: 'inline-block' }}
          >
            Book a Demo
          </a>
          <a 
            href="/contact" 
            className="secondary-btn" 
            style={{ textDecoration: 'none', display: 'inline-block' }}
          >
            Contact
          </a>
            </div>
          </div>

          <div className="image-frame-shape">
            <img src={Shape} alt="City" />
          </div>
        </div>
      </section>
    </motion.section>
  );
};

export default ShapeSection;